import { axiosInstance } from '@/http-common';
import { getCompanyFromJwt } from '@/crud/getters';

function isNotEmpty(value: any): boolean {
    return value !== undefined && value !== null && value !== '';
}

interface LoadParams {
    skip?: number;
    take?: number;
    sort?: any;
    filter?: any;
}

export async function getNotificationsHistoryList(
    params: LoadParams = {}
): Promise<any> {
    const queryParams: any = {};

    if (isNotEmpty(params.skip)) queryParams.skip = params.skip;
    if (isNotEmpty(params.take)) queryParams.take = params.take;

    if (isNotEmpty(params.sort)) {
        queryParams.sort = JSON.stringify(params.sort);
    }

    if (isNotEmpty(params.filter)) {
        queryParams.filter = JSON.stringify(params.filter);
    }

    const companyId = getCompanyFromJwt();

    if (companyId) {
        queryParams.companyId = companyId;
    }

    return axiosInstance
        .get(`/api/v1/notification-history/${companyId}`, { params: queryParams })
        .then((response) => {
            const data = response.data.data.result || response.data.result || response.data.data || response.data;
            return {
                data: data,
                totalCount: response.data.totalCount || data.length,
            };
        });
}

/**
 * Get asset notification history with hierarchical filtering
 * User sees notifications from their assigned asset groups and descendants only
 * @param params - Load parameters (skip, take, sort, filter)
 * @returns Promise with data and totalCount
 */
export async function getAssetNotificationHistoryList(
    params: LoadParams = {}
): Promise<any> {
    const queryParams: any = {};

    if (isNotEmpty(params.skip)) queryParams.skip = params.skip;
    if (isNotEmpty(params.take)) queryParams.take = params.take;

    if (isNotEmpty(params.sort)) {
        queryParams.sort = JSON.stringify(params.sort);
    }

    if (isNotEmpty(params.filter)) {
        queryParams.filter = JSON.stringify(params.filter);
    }

    const companyId = getCompanyFromJwt();

    return axiosInstance
        .get(`/api/v1/asset-notification-history/user/${companyId}`, { params: queryParams })
        .then((response) => {
            const data = response.data.data || response.data;
            return {
                data: data,
                totalCount: response.data.totalCount || data.length,
            };
        });
}
